import { Directive, Input } from "@angular/core";

import { GridFilterGroup } from "@hermes/states/grid-filters-state";
import { SanitizePipe } from "@hermes/utils-generic/pipes/sanitize";

/**
 * Abstract component for the filters behavior
 */
@Directive()
export abstract class ApolloFilterComponent {
    /** Filter group from parent */
    @Input()
    public filterGroup: GridFilterGroup;
    /** Boolean to know if  */
    @Input()
    public isExpanded: boolean;

    constructor(public sanitizePipe: SanitizePipe) {}

    public getFilterGroup(): GridFilterGroup {
        return this.filterGroup;
    }

    public getSanitizedFilterGroupTitle(): string {
        return this.sanitizePipe.transform(this.filterGroup.name);
    }
}
